/* tslint:disable:max-line-length */
import * as React from 'react';
import pure from 'recompose/pure';

class PinIcon extends React.Component<{ style: any }> {
  render() {
    return <svg
      fill="currentcolor"
      width="24px"
      height="24px"
      viewBox="0 0 24 24"{...this.props}>
      <g id="pin">
        <path
          d="M5.49879875,12.6023717 C4.71464519,11.4892974 4.20726736,10.1672121 4.07674766,8.73619798 C3.87510634,7.30109822 4.07079851,5.99779967 4.66382416,4.82630233 C4.76132845,4.63368668 4.8614233,4.44875428 4.96379834,4.27119879 C5.49996352,3.25539751 6.24834993,2.36895681 7.14994681,1.67088747 C9.31427817,-0.0589801051 11.569703,0.000243212892 12.0433474,0.000243212892 C12.1450346,0.000243212892 12.3756591,-0.000170730023 12.6985405,0.0266874368 C12.9919871,0.0504739222 13.2809577,0.0900965856 13.5645966,0.144699721 C15.2454129,0.462470903 17.8688645,1.47921295 19.3981786,4.73227098 C19.9027088,5.80547506 20.1171863,6.95091672 20.0416112,8.16859597 C20.0068927,9.85035483 19.4532067,11.4045935 18.5342019,12.6776631 L12.0433474,24.0002432 L5.49879875,12.6023717 Z M12.0433474,11.0002432 C13.7002017,11.0002432 15.0433474,9.65709746 15.0433474,8.00024321 C15.0433474,6.34338896 13.7002017,5.00024321 12.0433474,5.00024321 C10.3864932,5.00024321 9.04334744,6.34338896 9.04334744,8.00024321 C9.04334744,9.65709746 10.3864932,11.0002432 12.0433474,11.0002432 Z"
          id="Oval-5"
        />
      </g>
    </svg>;
  }
}

const Icon = pure(PinIcon);
Icon.displayName = 'PinIcon';
export default Icon;
